module.exports = __webpack_public_path__ + "img/logo.77337386.svg";